import { Loader } from "@/components";
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement, useCallback, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import classes from "./Duplicate.module.scss";

export const Duplicate: FunctionComponent = observer((): ReactElement => {
  const store = useStore();
  const navigate = useNavigate();
  const params = useParams() as { sessionUuid: string };
  const [searchParams] = useSearchParams();

  const doLoad = useCallback(async (): Promise<void> => {
    try {
      const { token, refreshToken } = await store.auth.readSession(
        params.sessionUuid
      );

      await store.auth.duplicateSession(token, refreshToken);
      await store.app.healthCheck();
      await store.app.load();

      navigate(searchParams.get("returnUrl") || "/", { replace: true });
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect((): void => {
    if (store.app.logged) {
      navigate(searchParams.get("returnUrl") || "/", { replace: true });

      return;
    }

    doLoad();
  }, []);

  return <Loader className={classes.Loader} />;
});
